import { getState } from 'live/redux/selectors/index.shared';
import get from 'lodash/get';
import { createSelector } from 'reselect';

// get games list

const typeSelector = (_, props) => props.type;
const getGameState = createSelector([getState, typeSelector], (state, type) =>
  get(state.games, type),
);

export const getGames = createSelector(getGameState, state =>
  get(state, 'list'),
);

export const getGamesLoading = createSelector(getGameState, state =>
  get(state, 'loading'),
);

export const getGamesError = createSelector(getGameState, state =>
  get(state, 'error'),
);

export const getGamesTotalPages = createSelector(getGameState, state =>
  get(state, 'totalPages'),
);
